import { render, staticRenderFns } from "./VendorDetail.vue?vue&type=template&id=b1590e1a&scoped=true&"
import script from "./VendorDetail.vue?vue&type=script&lang=js&"
export * from "./VendorDetail.vue?vue&type=script&lang=js&"
import style0 from "./VendorDetail.vue?vue&type=style&index=0&id=b1590e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1590e1a",
  null
  
)

export default component.exports